import { isHandball } from '../sportConfig';

export const white = '#f3f4f6';
export const black = '#0c1426';

export const yellow = '#fae78a';
export const red = '#ea3053';
export const blue = '#4183c4';
export const green = '#25D882';

// Shared UI border/background blues. Handball uses its own client BLUE palette
// so the UI chrome (panels, buttons, sections) matches the blue court identity;
// waterpolo keeps its original blues (distinct navy/steel tones).
//   #2d4e95 (medium) -> #2f5fa5 ; #142343/#1e3464 (dark) -> #112a52
export const lighterBlueBorder = isHandball ? '#2f5fa5' : '#2d4e95';
export const darkBlueBorder = isHandball ? '#112a52' : '#142343';
export const darkBlueBackground = isHandball ? '#112a52' : '#1e3464';
export const lighterBlueBackground = lighterBlueBorder;

export const darkerGrey = '#3F3F46';
export const darkGrey = '#8b94a7';
export const lightGrey = '#c5c9d3';
export const lighterGrey = '#e6e7ec';

// --- Handball palette -------------------------------------------------------
// Added unconditionally; unused in the waterpolo build (tree-shaken / harmless).
// Consumed by Pool.handball.tsx, the splash/auth gradients and the handball UI
// accent.
export const whiteOpacity = 'rgba(243, 244, 246, 0.5)';
export const yellow2 = '#efd684';

export const handballOrange = '#E4C49B';
export const handballOrangeOpacity = 'rgba(255, 101, 102, 0.5)';
export const handballYellow = '#efd684';
export const handballYellow2 = '#ac8b61';
export const handballLightBlue = '#4893e7';
export const handballBlue = '#09316f';
export const handballDarkBlue = '#122242';
// Dark-mode fill for the handball goal area (6 m D).
export const handballGoalAreaDark = '#d7a86e';

// --- Handball COURT palettes (two modes) -------------------------------------
// Client-specified BLUE identity (real handball court: light-blue playing
// surface, dark-blue goal-area D). Player disks are white-ringed (red #ea3053,
// blue #4183c4, grey #9ca3af, yellow #fae78a), so the blue disk stays legible
// against the blue court via the ring + a clear lightness gap between court and
// disk. The two modes share one blue identity so toggling reads as dimming.
//
// LIGHT — light-blue court base, dark-blue goal area (accent), white lines,
// paler-blue surround.
export const handballLightCourt = '#5b9bd8';
export const handballLightGoalArea = '#0d3268';
export const handballLightLines = '#ffffff';
export const handballLightBehindGoal = '#0a2750';
export const handballLightSurround = '#93bde8';
export const handballLightSurroundEdge = '#6fa4da';
//
// DARK — deep-navy court base, lighter-blue goal area (accent), soft-white
// lines, near-black navy surround.
export const handballDarkCourt = '#112a52';
export const handballDarkGoalArea = '#2f6bb5';
export const handballDarkLines = '#eaf1fb';
export const handballDarkBehindGoal = '#0a1c38';
export const handballDarkSurround = '#0a1c38';
export const handballDarkSurroundEdge = '#040d1c';

// --- Sport-gated semantic tokens -------------------------------------------
// UI accent (primary button fill, input focus/caret, section border). Handball
// swaps the bright waterpolo yellow for a duller gold. Gated centrally instead
// of per-component import aliasing, so the global `yellow` (used in ~30 files)
// stays untouched.
export const accentYellow = isHandball ? yellow2 : yellow;

// Inactive paginator page-number colour (PlayBrowser). Handball uses a pale
// blue to match the blue identity; waterpolo keeps the bright blue (`blue`).
export const paginatorInactive = isHandball ? '#a9c4e6' : blue;

// Radial-gradient start colour for the auth screen and splash screen.
export const authGradientStart = isHandball
  ? handballLightBlue
  : lighterBlueBackground;
export const splashGradientStart = isHandball
  ? handballLightBlue
  : lighterBlueBackground;

// --- Planner feature tokens -------------------------------------------------
// Dark modal background gradient (the full-screen Create/Edit/Details modals).
// Navy in waterpolo -> deep navy in handball.
export const plannerModalBgStart = isHandball ? '#112238' : '#1a2332';
export const plannerModalBgEnd = isHandball ? '#060d18' : '#0a0e14';
// FullCalendar "today"/selection accent (planner.css, via CSS custom props).
// Bright blue in waterpolo -> handball blue; hover is the darker shade.
export const plannerAccent = isHandball ? '#2f5fa5' : '#42a5f5';
export const plannerAccentHover = isHandball ? '#264f8a' : '#1e88e5';
// RGB triplet of the accent for building rgba() tints in CSS custom props.
export const plannerAccentRgb = isHandball ? '47, 95, 165' : '66, 165, 245';
